import React, { Component } from "react";
import styles from "../../../assets/css/modules/myprofile/myprofilecontactprefs.css";

const child ={
  float: 'left',
  paddingTop:'8px',
  paddingLeft:'14px'
};
const childlink ={
  float: 'left',
  paddingLeft:'10px',
  marginTop:'4px',
};

export class FormGroupCheckbox extends Component {
render() {

if (this.props.type === "checkbox") {
    if (this.props.Zebrafied) {
      return (
        <label className={this.props.mfa?styles.parentMfa:styles.parent} > 
          <div style={child}>
          <input
          className={this.props.mfa?styles.inputCheckBox:""}
                        id={"chk" + this.props.id}
                        key={"chk" + this.props.id}
                        type="checkbox"                         
                        onChange={this.props.onChange}                        
                      />
          </div>
          <div style={childlink}>
            <React.Fragment>
              <label htmlFor={this.props.id} className="m-0 align-middle">
                {this.props.label}
              </label>
            </React.Fragment>
          </div>
        </label>     
         
      );
    }
    return (
      <div></div> 
    );
  } 
}
}
export default FormGroupCheckbox;
